export default __webpack_public_path__ + "static/cordSide-67d30f91c7f22b8fe3e2bace1abcd358.svg";